// extracted by mini-css-extract-plugin
module.exports = {"stack":"Stack_stack__2DGWM"};